import * as React from "react"

export const ResourceStack = () => {
  const [theme, setTheme] = React.useState<string | null>("")
  React.useEffect(() => {
    const interval = setInterval(() => {
      const currentTheme = localStorage.getItem("theme")
      setTheme(currentTheme)
    }, 500)

    return () => clearInterval(interval)
  }, [])
  return (
    <>
      <div className="container mx-auto mt-10 lg:mt-0">
        <div>
          <p className="lg:text-5xl md:text-3xl text-[16px] text-black font-semibold text-center">
            Do you want guidance on picking a <br /> specific stack for a
            project?
          </p>
        </div>
        <div className="flex flex-wrap gap-3 lg:justify-center mx-3 mt-10">
          <div className="lg:p-2 p-1 lg:w-[45%] w-full">
            <div
              className={`w-full py-5 px-5 rounded-2xl h-full ${theme == "glassy" ? "bg-[rgba(255,255,255,0.24)] border border-white" : theme === "light" ? "bg-real-time-options" : theme === "dark" ? "bg-real-time-options" : "bg-[rgba(255,255,255,0.24)] border border-white"}`}
            >
              <p className=" py-3 font-semibold text-[#7B68EC]">
                Frontend-Only Stacks
              </p>
              <p className="font-semibold text-black text-sm">
                HTML, CSS, JavaScript{" "}
              </p>
              <p className="text-xs pt-2 text-black">
                <span className="font-semibold text-sm">JAMstack:</span>{" "}
                JavaScript, APIs, and Markup (for static sites and serverless
                architecture)
              </p>
              <p className="text-xs pt-2 text-black">
                <span className="font-semibold text-sm">SPAs:</span> Single Page
                Applications with React, Nextjs, Angular, or Vue.js
              </p>
            </div>
          </div>
          <div className="lg:p-2 p-1 lg:w-[45%] w-full">
            <div
              className={`w-full py-5 px-5 rounded-2xl h-full ${theme == "glassy" ? "bg-[rgba(255,255,255,0.24)] border border-white" : theme === "light" ? "bg-real-time-options" : theme === "dark" ? "bg-real-time-options" : "bg-[rgba(255,255,255,0.24)] border border-white"}`}
            >
              <p className=" py-3 font-semibold text-[#7B68EC]">
                Mobile apps Development Stacks
              </p>

              <p className="text-xs pt-2 text-black">
                <span className="font-semibold text-sm">Flutter Stack:</span>{" "}
                Dart, Flutter, Firebase/Custom Backend
              </p>
              <p className="text-xs pt-2 text-black">
                <span className="font-semibold text-sm">
                  React Native Stack:
                </span>{" "}
                React Native, Node.js, Express, MongoDB/PostgreSQL
              </p>
              <p className="text-xs pt-2 text-black">
                <span className="font-semibold text-sm">Native Mobile:</span>{" "}
                Java/Kotlin (Android), Swift/Objective-C (iOS)
              </p>
            </div>
          </div>
        </div>
        <div className="flex flex-wrap gap-3 lg:justify-center mx-3 mt-2">
          <div className="lg:p-2 p-1 lg:w-[45%] w-full">
            <div
              className={`w-full py-5 px-5 rounded-2xl h-full ${theme == "glassy" ? "bg-[rgba(255,255,255,0.24)] border border-white" : theme === "light" ? "bg-real-time-options" : theme === "dark" ? "bg-real-time-options" : "bg-[rgba(255,255,255,0.24)] border border-white"}`}
            >
              <p className=" py-3 font-semibold text-[#7B68EC]">
                Backend-Only Stacks
              </p>

              <p className="text-xs pt-2 text-black">
                <span className="font-semibold text-sm">LAMP:</span> Linux,
                Apache, MySQL, PHP
              </p>
              <p className="text-xs pt-2 text-black">
                <span className="font-semibold text-sm">LEMP:</span> Linux,
                Nginx, MySQL, PHP
              </p>
              <p className="text-xs pt-2 text-black">
                <span className="font-semibold text-sm">Django Stack:</span>{" "}
                Python, Django, PostgreSQL
              </p>
              <p className="text-xs pt-2 text-black">
                <span className="font-semibold text-sm">
                  Spring Boot Stack:
                </span>{" "}
                Java, Spring Boot, MySQL/PostgreSQL
              </p>
            </div>
          </div>
          <div className="lg:p-2 p-1 lg:w-[45%] w-full">
            <div
              className={`w-full py-5 px-5 rounded-2xl h-full ${theme == "glassy" ? "bg-[rgba(255,255,255,0.24)] border border-white" : theme === "light" ? "bg-real-time-options" : theme === "dark" ? "bg-real-time-options" : "bg-[rgba(255,255,255,0.24)] border border-white"}`}
            >
              <p className=" py-3 font-semibold text-[#7B68EC]">
                Data Science & Machine Learning Stacks
              </p>

              <p className="text-xs pt-2 text-black">
                <span className="font-semibold text-sm">PyData Stack:</span>{" "}
                Python, NumPy, pandas, Matplotlib, scikit-learn
              </p>
              <p className="text-xs pt-2 text-black">
                <span className="font-semibold text-sm">TensorFlow Stack:</span>{" "}
                TensorFlow, Keras, Python, Flask/Django
              </p>
            </div>
          </div>
        </div>
        <div className="flex flex-wrap gap-3 lg:justify-center mx-3 mt-2">
          <div className="lg:p-2 p-1 lg:w-[45%] w-full">
            <div
              className={`w-full py-5 px-5 rounded-2xl h-full ${theme == "glassy" ? "bg-[rgba(255,255,255,0.24)] border border-white" : theme === "light" ? "bg-real-time-options" : theme === "dark" ? "bg-real-time-options" : "bg-[rgba(255,255,255,0.24)] border border-white"}`}
            >
              <p className=" py-3 font-semibold text-[#7B68EC]">
                Full-Stack Development Stacks*
              </p>

              <p className="text-xs pt-2 text-black">
                <span className="font-semibold text-sm">⁠MEAN Stack:</span>{" "}
                MongoDB, Express.js, Angular, Node.js
              </p>
              <p className="text-xs pt-2 text-black">
                <span className="font-semibold text-sm">MERN Stack:</span>{" "}
                MongoDB, Express.js, React, Nextjs, Node.js
              </p>
              <p className="text-xs pt-2 text-black">
                <span className="font-semibold text-sm">MEVN Stack:</span>{" "}
                MongoDB, Express.js, Vue.js, Node.js
              </p>
              <p className="text-xs pt-2 text-black">
                <span className="font-semibold text-sm">PERN Stack: </span>{" "}
                PostgreSQL, Express.js, React, Node.js
              </p>
              <p className="text-xs pt-2 text-black">
                <span className="font-semibold text-sm">LAMP Stack:</span>{" "}
                Linux, Apache, MySQL, PHP (also a full-stack option)
              </p>
            </div>
          </div>
          <div className="lg:p-2 p-1 lg:w-[45%] w-full">
            <div
              className={`w-full py-5 px-5 rounded-2xl h-full ${theme == "glassy" ? "bg-[rgba(255,255,255,0.24)] border border-white" : theme === "light" ? "bg-real-time-options" : theme === "dark" ? "bg-real-time-options" : "bg-[rgba(255,255,255,0.24)] border border-white"}`}
            >
              <p className=" py-3 font-semibold text-[#7B68EC]">
                Specialized Stacks
              </p>

              <p className="text-xs pt-2 text-black">
                <span className="font-semibold text-sm">Serverless Stack:</span>{" "}
                AWS Lambda, API Gateway, DynamoDB, S3
              </p>
              <p className="text-xs pt-2 text-black">
                <span className="font-semibold text-sm">IoT Stack:</span> MQTT,
                Node.js, Raspberry Pi, Arduino
              </p>
              <p className="text-xs pt-2 text-black">
                <span className="font-semibold text-sm">
                  Blockchain Stack:{" "}
                </span>
                Ethereum, Solidity, Web3.js, Node.js
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
